<template>
  <div>
    <div class="my-3">
      <em class="font-18 color-orange fa fa-info-circle mr-2" />
      <span class="color-black font-16 font-weight-bold">
        Información de Lugar de Servicio
      </span>
    </div>
    <div class="row">
      <div class="col">
        <div class="color-secondary-6 font-14">
          Tipo de Lugar:
        </div>
        <span class="color-black font-16">
          {{ data.locationType | empty }}
        </span>
      </div>
      <div v-if="isSchoolPlace(data)" class="col">
        <div class="color-secondary-6 font-14">
          Región:
        </div>
        <span class="color-black font-16">
          {{ data.regionName }}
        </span>
      </div>
      <div v-if="isSchoolPlace(data)" class="col">
        <div class="color-secondary-6 font-14">
          Distrito:
        </div>
        <span class="color-black font-16">
          {{ data.districtName }}
        </span>
      </div>
      <div v-if="isSchoolPlace(data)" class="col">
        <div class="color-secondary-6 font-14">
          Escuela:
        </div>
        <span class="color-black font-16">
          {{ data.schoolCode }} - {{ data.schoolName }}
        </span>
      </div>
      <div v-if="isMunicipalityVisible(data)" class="col">
        <div class="color-secondary-6 font-14">
          Municipio:
        </div>
        <span class="color-black font-16">
          {{ data.municipalityName }}
        </span>
      </div>
      <div v-if="isServicePlaceVisible(data)" class="col">
        <div class="color-secondary-6 font-14">
          Lugar de Servicio:
        </div>
        <span class="color-black font-16">
          {{ data.locationName }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import locationTypes from '@/utils/constants/locationTypes.js';
export default {
  name: 'LocationServiceInfo',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isSchoolPlace() {
      return (item) => item.locationTypeId == locationTypes.Escuela;
    },
    isMunicipalityVisible() {
      return (item) =>
        [
          locationTypes.OfficinaProveedor,
          locationTypes.CSEE,
          locationTypes.CAAT,
          locationTypes.Hogar,
        ].includes(item.locationTypeId);
    },
    isServicePlaceVisible() {
      return (item) =>
        [locationTypes.OfficinaProveedor, locationTypes.CAAT].includes(
          item.locationTypeId
        );
    },
  },
};
</script>
